function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import Log from '@deephaven/log';
import { DateUtils, TableUtils } from '@deephaven/jsapi-utils';
import { makeColumnFormatColumn, makeRowFormatColumn, makeTernaryFormatRule } from "./ConditionalFormattingAPIUtils.js";
var log = Log.module('ConditionalFormattingUtils');
export var FormatterType = /*#__PURE__*/function (FormatterType) {
  FormatterType["CONDITIONAL"] = "conditional";
  FormatterType["ROWS"] = "rows";
  return FormatterType;
}({});
export var NumberCondition = /*#__PURE__*/function (NumberCondition) {
  NumberCondition["IS_EQUAL"] = "is-equal";
  NumberCondition["IS_NOT_EQUAL"] = "is-not-equal";
  NumberCondition["IS_BETWEEN"] = "is-between";
  NumberCondition["GREATER_THAN"] = "greater-than";
  NumberCondition["GREATER_THAN_OR_EQUAL"] = "greater-than-or-equal";
  NumberCondition["LESS_THAN"] = "less-than";
  NumberCondition["LESS_THAN_OR_EQUAL"] = "less-than-or-equal";
  NumberCondition["IS_NULL"] = "is-null";
  NumberCondition["IS_NOT_NULL"] = "is-not-null";
  return NumberCondition;
}({});
export var StringCondition = /*#__PURE__*/function (StringCondition) {
  StringCondition["IS_EXACTLY"] = "is-exactly";
  StringCondition["IS_NOT_EXACTLY"] = "is-not-exactly";
  StringCondition["CONTAINS"] = "contains";
  StringCondition["DOES_NOT_CONTAIN"] = "does-not-contain";
  StringCondition["STARTS_WITH"] = "starts-with";
  StringCondition["ENDS_WITH"] = "ends-with";
  StringCondition["IS_NULL"] = "is-null";
  StringCondition["IS_NOT_NULL"] = "is-not-null";
  return StringCondition;
}({});
export var DateCondition = /*#__PURE__*/function (DateCondition) {
  DateCondition["IS_EXACTLY"] = "is-exactly";
  DateCondition["IS_NOT_EXACTLY"] = "is-not-exactly";
  DateCondition["IS_BEFORE"] = "is-before";
  DateCondition["IS_BEFORE_OR_EQUAL"] = "is-before-or-equal";
  DateCondition["IS_AFTER"] = "is-after";
  DateCondition["IS_AFTER_OR_EQUAL"] = "is-after-or-equal";
  DateCondition["IS_NULL"] = "is-null";
  DateCondition["IS_NOT_NULL"] = "is-not-null";
  return DateCondition;
}({});
export var BooleanCondition = /*#__PURE__*/function (BooleanCondition) {
  BooleanCondition["IS_TRUE"] = "is-true";
  BooleanCondition["IS_FALSE"] = "is-false";
  BooleanCondition["IS_EQUAL"] = "is-equal";
  BooleanCondition["IS_NOT_EQUAL"] = "is-not-equal";
  BooleanCondition["IS_NULL"] = "is-null";
  BooleanCondition["IS_NOT_NULL"] = "is-not-null";
  return BooleanCondition;
}({});
export var CharCondition = /*#__PURE__*/function (CharCondition) {
  CharCondition["IS_EQUAL"] = "is-equal";
  CharCondition["IS_NOT_EQUAL"] = "is-not-equal";
  CharCondition["IS_NULL"] = "is-null";
  CharCondition["IS_NOT_NULL"] = "is-not-null";
  return CharCondition;
}({});
export var FormatStyleType = /*#__PURE__*/function (FormatStyleType) {
  FormatStyleType["NO_FORMATTING"] = "no-formatting";
  FormatStyleType["POSITIVE"] = "positive";
  FormatStyleType["NEGATIVE"] = "negative";
  FormatStyleType["WARN"] = "warn";
  FormatStyleType["NEUTRAL"] = "neutral";
  FormatStyleType["ACCENT_1"] = "accent-1";
  FormatStyleType["ACCENT_2"] = "accent-2";
  FormatStyleType["CUSTOM"] = "custom";
  return FormatStyleType;
}({});
export function getLabelForStyleType(option) {
  switch (option) {
    case FormatStyleType.NO_FORMATTING:
      return 'No formatting';
    case FormatStyleType.POSITIVE:
      return 'Positive';
    case FormatStyleType.NEGATIVE:
      return 'Negative';
    case FormatStyleType.WARN:
      return 'Warn';
    case FormatStyleType.NEUTRAL:
      return 'Neutral';
    case FormatStyleType.ACCENT_1:
      return 'Accent 1';
    case FormatStyleType.ACCENT_2:
      return 'Accent 2';
    case FormatStyleType.CUSTOM:
      return 'Custom...';
  }
}
export function getBackgroundForStyleConfig(config) {
  var type = config.type,
    customConfig = config.customConfig;
  switch (type) {
    case FormatStyleType.NO_FORMATTING:
      return undefined;
    case FormatStyleType.POSITIVE:
      return '#9fde6f';
    case FormatStyleType.NEGATIVE:
      return '#ff6087';
    case FormatStyleType.WARN:
      return '#f67f40';
    case FormatStyleType.NEUTRAL:
      return '#ffd95c';
    case FormatStyleType.ACCENT_1:
      return '#78dce8';
    case FormatStyleType.ACCENT_2:
      return '#ab9bf5';
    case FormatStyleType.CUSTOM:
      return customConfig === null || customConfig === void 0 ? void 0 : customConfig.background;
    default:
      return undefined;
  }
}
export function getColorForStyleConfig(config) {
  var type = config.type,
    customConfig = config.customConfig;
  switch (type) {
    case FormatStyleType.NO_FORMATTING:
      return undefined;
    case FormatStyleType.POSITIVE:
      return '#526a3f';
    case FormatStyleType.NEGATIVE:
      return '#802f44';
    case FormatStyleType.WARN:
      return '#663318';
    case FormatStyleType.NEUTRAL:
      return '#63562b';
    case FormatStyleType.ACCENT_1:
      return '#3f6469';
    case FormatStyleType.ACCENT_2:
      return '#554d72';
    case FormatStyleType.CUSTOM:
      return customConfig === null || customConfig === void 0 ? void 0 : customConfig.color;
    default:
      return undefined;
  }
}
export function getStyleDBString(config) {
  var color = getColorForStyleConfig(config.style);
  var bg = getBackgroundForStyleConfig(config.style);
  if (color === undefined || bg === undefined) {
    return undefined;
  }
  return "bgfg(`".concat(bg, "`, `").concat(color, "`)");
}

/**
 * Formats a rightHandValue for use in a condition expression.
 * - If a ModelColumn: returns the column name as a bare identifier (no quoting)
 * - If a string: wraps it in the given quote character
 * - If undefined: returns undefined
 */
export function formatRHV(value, quote) {
  if (value === undefined) return undefined;
  if (typeof value === 'object') return value.name;
  return "".concat(quote).concat(value).concat(quote);
}

/**
 * Formats a date rightHandValue for use in a condition expression.
 * - If a ModelColumn: returns the column name (no quoting or timezone processing)
 * - If a string: reformats the timezone and wraps in single quotes
 */
function formatDateRHV(dh, value) {
  if (value === undefined) return undefined;
  if (typeof value === 'object') return value.name;
  var _value$split = value.split(' '),
    _value$split2 = _toArray(_value$split),
    dateTimeString = _value$split2[0],
    rest = _value$split2.slice(1);
  var tzCode = rest.join(' ');
  var tz = dh.i18n.TimeZone.getTimeZone(tzCode);
  return "'".concat(dateTimeString, " ").concat(tz.id, "'");
}
function getNumberConditionText(config) {
  var leftHandValue = config.leftHandValue,
    rightHandValue = config.rightHandValue,
    start = config.start,
    end = config.end;
  return getTextForNumberCondition(leftHandValue.name, config.condition, formatRHV(rightHandValue, ''), start, end);
}
function getStringConditionText(config) {
  var leftHandValue = config.leftHandValue,
    rightHandValue = config.rightHandValue;
  var columnName = leftHandValue.name;
  var rhv = formatRHV(rightHandValue, '"');
  switch (config.condition) {
    case StringCondition.IS_EXACTLY:
      return "".concat(columnName, " == ").concat(rhv);
    case StringCondition.IS_NOT_EXACTLY:
      return "".concat(columnName, " != ").concat(rhv);
    case StringCondition.CONTAINS:
      return "".concat(columnName, " != null && ").concat(columnName, ".contains(").concat(rhv, ")");
    case StringCondition.DOES_NOT_CONTAIN:
      return "".concat(columnName, " != null && !").concat(columnName, ".contains(").concat(rhv, ")");
    case StringCondition.STARTS_WITH:
      return "".concat(columnName, " != null && ").concat(columnName, ".startsWith(").concat(rhv, ")");
    case StringCondition.ENDS_WITH:
      return "".concat(columnName, " != null && ").concat(columnName, ".endsWith(").concat(rhv, ")");
    case StringCondition.IS_NULL:
      return "".concat(columnName, " == null");
    case StringCondition.IS_NOT_NULL:
      return "".concat(columnName, " != null");
  }
}
function getDateConditionText(dh, config) {
  var leftHandValue = config.leftHandValue,
    rightHandValue = config.rightHandValue;
  var columnName = leftHandValue.name;
  var rhv = formatDateRHV(dh, rightHandValue);
  switch (config.condition) {
    case DateCondition.IS_EXACTLY:
      return "".concat(columnName, " == ").concat(rhv);
    case DateCondition.IS_NOT_EXACTLY:
      return "".concat(columnName, " != ").concat(rhv);
    case DateCondition.IS_BEFORE:
      return "".concat(columnName, " < ").concat(rhv);
    case DateCondition.IS_BEFORE_OR_EQUAL:
      return "".concat(columnName, " <= ").concat(rhv);
    case DateCondition.IS_AFTER:
      return "".concat(columnName, " > ").concat(rhv);
    case DateCondition.IS_AFTER_OR_EQUAL:
      return "".concat(columnName, " >= ").concat(rhv);
    case DateCondition.IS_NULL:
      return "".concat(columnName, " == null");
    case DateCondition.IS_NOT_NULL:
      return "".concat(columnName, " != null");
  }
}
function getBooleanConditionText(config) {
  var leftHandValue = config.leftHandValue,
    rightHandValue = config.rightHandValue;
  return getTextForBooleanCondition(leftHandValue.name, config.condition, rightHandValue);
}
function getCharConditionText(config) {
  var leftHandValue = config.leftHandValue,
    rightHandValue = config.rightHandValue;
  var columnName = leftHandValue.name;
  var rhv = formatRHV(rightHandValue, "'");
  switch (config.condition) {
    case CharCondition.IS_EQUAL:
      return "".concat(columnName, " == ").concat(rhv);
    case CharCondition.IS_NOT_EQUAL:
      return "".concat(columnName, " != ").concat(rhv);
    case CharCondition.IS_NULL:
      return "isNull(".concat(columnName, ")");
    case CharCondition.IS_NOT_NULL:
      return "!isNull(".concat(columnName, ")");
  }
}
export function getConditionDBString(dh, config) {
  var leftHandValue = config.leftHandValue;
  if (TableUtils.isNumberType(leftHandValue.type)) {
    return getNumberConditionText(config);
  }
  if (TableUtils.isCharType(leftHandValue.type)) {
    return getCharConditionText(config);
  }
  if (TableUtils.isStringType(leftHandValue.type)) {
    return getStringConditionText(config);
  }
  if (TableUtils.isDateType(leftHandValue.type)) {
    return getDateConditionText(dh, config);
  }
  if (TableUtils.isBooleanType(leftHandValue.type)) {
    return getBooleanConditionText(config);
  }
  throw new Error('Invalid column type');
}
export function getLabelForNumberCondition(condition) {
  switch (condition) {
    case NumberCondition.IS_EQUAL:
      return 'is equal to';
    case NumberCondition.IS_NOT_EQUAL:
      return 'is not equal to';
    case NumberCondition.IS_BETWEEN:
      return 'is between';
    case NumberCondition.GREATER_THAN:
      return 'greater than';
    case NumberCondition.GREATER_THAN_OR_EQUAL:
      return 'greater than or equal to';
    case NumberCondition.LESS_THAN:
      return 'less than';
    case NumberCondition.LESS_THAN_OR_EQUAL:
      return 'less than or equal to';
    case NumberCondition.IS_NULL:
      return 'is null';
    case NumberCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
export function getLabelForStringCondition(condition) {
  switch (condition) {
    case StringCondition.IS_EXACTLY:
      return 'is exactly';
    case StringCondition.IS_NOT_EXACTLY:
      return 'is not exactly';
    case StringCondition.CONTAINS:
      return 'contains';
    case StringCondition.DOES_NOT_CONTAIN:
      return 'does not contain';
    case StringCondition.STARTS_WITH:
      return 'starts with';
    case StringCondition.ENDS_WITH:
      return 'ends with';
    case StringCondition.IS_NULL:
      return 'is null';
    case StringCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
export function getLabelForDateCondition(condition) {
  switch (condition) {
    case DateCondition.IS_EXACTLY:
      return 'is';
    case DateCondition.IS_NOT_EXACTLY:
      return 'is not';
    case DateCondition.IS_BEFORE:
      return 'is before';
    case DateCondition.IS_BEFORE_OR_EQUAL:
      return 'is before or equal';
    case DateCondition.IS_AFTER:
      return 'is after';
    case DateCondition.IS_AFTER_OR_EQUAL:
      return 'is after or equal';
    case DateCondition.IS_NULL:
      return 'is null';
    case DateCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
export function getLabelForBooleanCondition(condition) {
  switch (condition) {
    case BooleanCondition.IS_TRUE:
      return 'is true';
    case BooleanCondition.IS_FALSE:
      return 'is false';
    case BooleanCondition.IS_EQUAL:
      return 'is equal to';
    case BooleanCondition.IS_NOT_EQUAL:
      return 'is not equal to';
    case BooleanCondition.IS_NULL:
      return 'is null';
    case BooleanCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
export function getLabelForCharCondition(condition) {
  switch (condition) {
    case CharCondition.IS_EQUAL:
      return 'is';
    case CharCondition.IS_NOT_EQUAL:
      return 'is not';
    case CharCondition.IS_NULL:
      return 'is null';
    case CharCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
export function getDefaultConditionForType(columnType) {
  if (TableUtils.isNumberType(columnType)) {
    return NumberCondition.IS_EQUAL;
  }
  if (TableUtils.isCharType(columnType)) {
    return CharCondition.IS_EQUAL;
  }
  if (TableUtils.isStringType(columnType)) {
    return StringCondition.IS_EXACTLY;
  }
  if (TableUtils.isDateType(columnType)) {
    return DateCondition.IS_EXACTLY;
  }
  if (TableUtils.isBooleanType(columnType)) {
    return BooleanCondition.IS_TRUE;
  }
  throw new Error('Invalid column type');
}
export function getDefaultValueForType(columnType) {
  if (TableUtils.isStringType(columnType)) {
    return '';
  }
  return undefined;
}
export function getConditionConfig(config) {
  var condition = config.condition,
    rightHandValue = config.rightHandValue,
    start = config.start,
    end = config.end;
  return {
    condition,
    rightHandValue,
    start,
    end
  };
}
export function getDefaultConditionConfigForType(type) {
  return {
    condition: getDefaultConditionForType(type),
    rightHandValue: getDefaultValueForType(type),
    start: undefined,
    end: undefined
  };
}
export function getDefaultStyleConfig() {
  return {
    type: FormatStyleType.NO_FORMATTING
  };
}
function getShortLabelForStringCondition(condition) {
  switch (condition) {
    case StringCondition.IS_EXACTLY:
      return '==';
    case StringCondition.IS_NOT_EXACTLY:
      return '!=';
    case StringCondition.CONTAINS:
      return 'contains';
    case StringCondition.DOES_NOT_CONTAIN:
      return 'does not contain';
    case StringCondition.STARTS_WITH:
      return 'starts with';
    case StringCondition.ENDS_WITH:
      return 'ends with';
    case StringCondition.IS_NULL:
      return 'is null';
    case StringCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
function getShortLabelForDateCondition(condition) {
  switch (condition) {
    case DateCondition.IS_EXACTLY:
      return '==';
    case DateCondition.IS_NOT_EXACTLY:
      return '!=';
    case DateCondition.IS_BEFORE:
      return '<';
    case DateCondition.IS_BEFORE_OR_EQUAL:
      return '<=';
    case DateCondition.IS_AFTER:
      return '>';
    case DateCondition.IS_AFTER_OR_EQUAL:
      return '>=';
    case DateCondition.IS_NULL:
      return 'is null';
    case DateCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
function getShortLabelForBooleanCondition(condition) {
  switch (condition) {
    case BooleanCondition.IS_TRUE:
      return 'is true';
    case BooleanCondition.IS_FALSE:
      return 'is false';
    case BooleanCondition.IS_EQUAL:
      return '==';
    case BooleanCondition.IS_NOT_EQUAL:
      return '!=';
    case BooleanCondition.IS_NULL:
      return 'is null';
    case BooleanCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
function getShortLabelForCharCondition(condition) {
  switch (condition) {
    case CharCondition.IS_EQUAL:
      return '==';
    case CharCondition.IS_NOT_EQUAL:
      return '!=';
    case CharCondition.IS_NULL:
      return 'is null';
    case CharCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
export function getShortLabelForNumberCondition(condition) {
  switch (condition) {
    case NumberCondition.IS_EQUAL:
      return '==';
    case NumberCondition.IS_NOT_EQUAL:
      return '!=';
    case NumberCondition.IS_BETWEEN:
      return '==';
    case NumberCondition.GREATER_THAN:
      return '>';
    case NumberCondition.GREATER_THAN_OR_EQUAL:
      return '>=';
    case NumberCondition.LESS_THAN:
      return '<';
    case NumberCondition.LESS_THAN_OR_EQUAL:
      return '<=';
    case NumberCondition.IS_NULL:
      return 'is null';
    case NumberCondition.IS_NOT_NULL:
      return 'is not null';
  }
}
export function getTextForNumberCondition(columnName, condition, value, start, end) {
  switch (condition) {
    case NumberCondition.IS_EQUAL:
      return "".concat(columnName, " == ").concat(value);
    case NumberCondition.IS_NOT_EQUAL:
      return "".concat(columnName, " != ").concat(value);
    case NumberCondition.IS_BETWEEN:
      return "".concat(columnName, " > ").concat(start, " && ").concat(columnName, " < ").concat(end);
    case NumberCondition.GREATER_THAN:
      return "".concat(columnName, " > ").concat(value);
    case NumberCondition.GREATER_THAN_OR_EQUAL:
      return "".concat(columnName, " >= ").concat(value);
    case NumberCondition.LESS_THAN:
      return "".concat(columnName, " < ").concat(value);
    case NumberCondition.LESS_THAN_OR_EQUAL:
      return "".concat(columnName, " <= ").concat(value);
    case NumberCondition.IS_NULL:
      return "".concat(columnName, " == null");
    case NumberCondition.IS_NOT_NULL:
      return "".concat(columnName, " != null");
  }
}
export function getTextForBooleanCondition(columnName, condition, rightHandValue) {
  var _formatRHV, _formatRHV2;
  switch (condition) {
    case BooleanCondition.IS_TRUE:
      return "".concat(columnName, " == true");
    case BooleanCondition.IS_FALSE:
      return "".concat(columnName, " == false");
    case BooleanCondition.IS_EQUAL:
      return "".concat(columnName, " == ").concat((_formatRHV = formatRHV(rightHandValue, '')) !== null && _formatRHV !== void 0 ? _formatRHV : 'null');
    case BooleanCondition.IS_NOT_EQUAL:
      return "".concat(columnName, " != ").concat((_formatRHV2 = formatRHV(rightHandValue, '')) !== null && _formatRHV2 !== void 0 ? _formatRHV2 : 'null');
    case BooleanCondition.IS_NULL:
      return "".concat(columnName, " == null");
    case BooleanCondition.IS_NOT_NULL:
      return "".concat(columnName, " != null");
  }
}
export function getShortLabelForConditionType(columnType, condition) {
  if (TableUtils.isNumberType(columnType)) {
    return getShortLabelForNumberCondition(condition);
  }
  if (TableUtils.isCharType(columnType)) {
    return getShortLabelForCharCondition(condition);
  }
  if (TableUtils.isStringType(columnType)) {
    return getShortLabelForStringCondition(condition);
  }
  if (TableUtils.isDateType(columnType)) {
    return getShortLabelForDateCondition(condition);
  }
  if (TableUtils.isBooleanType(columnType)) {
    return getShortLabelForBooleanCondition(condition);
  }
  throw new Error('Invalid column type');
}

/**
 * Get format columns array for the given columns and formatting rules
 * @param columns Available columns
 * @param rules Formatting rules to build the format columns from
 * @returns Array of format columns
 */
export function getFormatColumns(dh, columns, rules) {
  if (rules === undefined) {
    log.debug("no rules passed.");
    return [];
  }
  var result = [];
  // There can be only one row format custom column
  // and multiple column format custom columns (one per column)
  var rowFormatConfig;
  var columnFormatConfigMap = new Map();
  rules.forEach(_ref => {
    var config = _ref.config,
      formatterType = _ref.type;
    var leftHandValue = config.leftHandValue,
      formattedColumns = config.formattedColumns;
    var isColumnType = formatterType === FormatterType.CONDITIONAL;

    // Check both name and type because the type can change
    var conditionCol = columns.find(_ref2 => {
      var name = _ref2.name,
        type = _ref2.type;
      return name === leftHandValue.name && type === leftHandValue.type;
    });
    if (conditionCol === undefined) {
      log.debug("Column ".concat(leftHandValue.name, ":").concat(leftHandValue.type, " not found. Ignoring format rule."), config);
      return;
    }

    // For COLUMNS rules, format each column in formattedColumns.
    // When formattedColumns is absent or empty, fall back to the condition column
    // by using [null] to indicate that the condition column should be used as the format target.
    var targetColConfigs = isColumnType && formattedColumns.length > 0 ? formattedColumns : [null];
    targetColConfigs.forEach(targetColConfig => {
      var _ref6;
      var formatTargetCol = conditionCol;
      if (isColumnType && targetColConfig !== null) {
        var found = columns.find(_ref3 => {
          var name = _ref3.name,
            type = _ref3.type;
          return name === targetColConfig.name && type === targetColConfig.type;
        });
        if (found === undefined) {
          log.debug("Formatted column ".concat(targetColConfig.name, ":").concat(targetColConfig.type, " not found. Ignoring format rule."), config);
          return;
        }
        formatTargetCol = found;
      }

      // Stack ternary format conditions by formatted column
      var _ref4 = (_ref6 = isColumnType ? columnFormatConfigMap.get(formatTargetCol.name) : rowFormatConfig) !== null && _ref6 !== void 0 ? _ref6 : ['null', undefined],
        _ref5 = _slicedToArray(_ref4, 2),
        prevRule = _ref5[0],
        prevFormatColumn = _ref5[1];
      var rule = makeTernaryFormatRule(dh, config, prevRule);
      if (rule === undefined) {
        log.debug("Ignoring format rule.", config);
        return;
      }
      // Replace existing formatColumn with the new stacked format
      var index = prevFormatColumn === undefined ? -1 : result.indexOf(prevFormatColumn);
      if (index > -1) {
        result.splice(index, 1);
      }
      var formatColumn = isColumnType ? makeColumnFormatColumn(formatTargetCol, rule) : makeRowFormatColumn(dh, rule);
      result.push(formatColumn);
      if (isColumnType) {
        columnFormatConfigMap.set(formatTargetCol.name, [rule, formatColumn]);
      } else {
        rowFormatConfig = [rule, formatColumn];
      }
    });
  });
  return result;
}

/**
 * Validate that a given date condition + value pair is valid.
 * @param condition
 * @param value
 */
export function isDateConditionValid(dh, condition, value) {
  switch (condition) {
    case DateCondition.IS_NULL:
    case DateCondition.IS_NOT_NULL:
      return true;
    default:
      {
        var _split = (value !== null && value !== void 0 ? value : '').split(' '),
          _split2 = _toArray(_split),
          dateTimeString = _split2[0],
          rest = _split2.slice(1);
        // Reconstitute all tokens after the first ' ' in case the user included garbage data at the end
        // e.g. '2020-01-01 NY blah'
        var tzCode = rest.join(' ');
        try {
          DateUtils.parseDateTimeString(dateTimeString);
        } catch (e) {
          log.debug('Invalid datetime string', dateTimeString);
          return false;
        }
        try {
          dh.i18n.TimeZone.getTimeZone(tzCode);
        } catch (e) {
          log.debug('Invalid timezone string', tzCode);
          return false;
        }
        return true;
      }
  }
}
export function isSupportedColumn(_ref7) {
  var type = _ref7.type;
  return TableUtils.isNumberType(type) || TableUtils.isCharType(type) || TableUtils.isStringType(type) || TableUtils.isDateType(type) || TableUtils.isBooleanType(type);
}
//# sourceMappingURL=ConditionalFormattingUtils.js.map